import styled from 'styled-components';
import background from "../../images/Blog.png"
import backgroundBg from "../../images/subscribeBg.png"

import background2 from "../../images/Blog2.png"


export const InfoContainer = styled.div`
  color: #000000;
  // background: url(${background})  right no-repeat;
  // background-image: url(${background}), url(${background2});
  background-position: right center, left center;
  background-repeat: no-repeat, no-repeat;
  background-size: 100px;
  background-size: contain !important;
  // background-color: #fcb03b;
  background-repeat: no-repeat; 
  @media screen and  (max-width: 768px) {
    padding: 100px 0;
  }
`
export const InfoWrapper = styled.div`
  display: grid;
  z-index: 1;
  height: 500px;
  width: 100%auto;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 24px;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 40px;
`
export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  background: url(${backgroundBg})  left no-repeat;
  background-size: 30px;
  background-size: contain !important;
  width: 890px;
  align-items: center;
  border-radius: 20px;
  
  background-color: #fff7eb;
  @media screen and (max-width: 768px) {
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)}
  }

  @media screen and (max-width: 960px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
export const Column1 = styled.div`
display: flex;
flex-direction:  row;
border-radius: 20px;
// background-color: #000000;
background: url(${backgroundBg})  right no-repeat;
background-size: cover !important;
align-items: center;
justify-content: center;
text-align: left;
  margin-bottom: 15px;
  // padding: 0 15px;
  // grid-area: col1;
  width: 55%;
  // background: #ffffff;
  height: 100%
  
`
export const Column2 = styled.div`
display: flex;
flex-direction:  column;
align-items: center;
justify-content: center;
  width: 40%;
`
export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 25px;
  // padding-bottom: 60px;
`
export const TopLine = styled.p`
  color: #8f8f8f;
  font-size: 15px;
  line-height: 16px;
  // font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`

export const Heading = styled.div`
  margin-bottom: 15px;
  font-size: 24px;
  padding-left: 30px;
  width: 70%;
  // line-height: 1.3;
  font-weight: 600;
  text-align : left;
  color: #2f2c2c;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`
export const Subtitle  = styled.p`
  padding-left: 30px;
  max-width: 340px;
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
`
export const BtnWrap = styled.div`
  display:flex;
  justify-content: flex-start;
`;
export const ImgWrap = styled.div`
  width: 100%;
  height: 100%;
`;
export const Img = styled.img`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
`;
